<template lang="pug">
Page
  template(slot="header-left-dropdown")
    div
  template(slot="content-center")
    TableLoading(v-if="isFetchingData")
    template(v-else)
      IntegrationItems(
        v-if="renderComponent && !isFetchingData"
        :list="IntegrationProductList",
        @openActionPopup="openPopup"
        @closeActionPopup="closeActionPopup"
        @activateModal="activateModal"
        @closeModal="closeModal"
      )

</template>

<script>
//
import IntegrationItems from './components/IntegrationItems'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Integration',

  components: {
    IntegrationItems
  },

  data () {
    return {
      renderComponent: true
    }
  },

  computed: {

    ...mapGetters('Integration', ['IntegrationProductList']),

    isFetchingData () {
      return this.$wait.is(['getAllLicenseList'])
    }
  },

  methods: {
    ...mapActions('Integration', ['getAllLicenseList', 'updateIBarIntegrationStatus']),

    getImage(image) {
      try {
        return `data:image/png;base64,${image}`
      } catch (error) {
        console.error('Image could not be loaded', error)
      }
    },
    async setData () {
      await this.getAllLicenseList()
    },

    openPopup (item) {
      item.showActionBar = !item.showActionBar
    },
    closeActionPopup (item) {
      item.showActionBar = false
      this.forceRerender()
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },

    closePopup () {
      this.showChangingWarning = false
      this.showPassiveWarning = false
      this.showLastWarning = false
      this.showFirstSelectWarning = false
    },
    
    activateModal (item) {
      item.isModalActive = true
    },
    closeModal (item) {
      item.isModalActive = false
      this.forceRerender()
    }
  },

  async beforeMount () {
    await this.setData()
  }
}
</script>

<style lang="scss" scoped>
  .description {
    font-weight: $font-weight-normal;
  }

</style>
